import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import SelectionToolbar from '@opsbase/web-data-selection/SelectionToolbar';
import useSelection from '@opsbase/web-data-selection/useSelection';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import PublishIcon from '@opsbase/web-icons/icons/PublishIcon';
import useNav from '@opsbase/web-nav/useNav';
import React, { useCallback, useMemo } from 'react';
export function OpDefinitionsSelectionToolbar() {
    const self = useSelf();
    const dataType = DataType.OPDEFINITION;
    const { selecteds } = useSelection(dataType);
    const { goTo } = useNav();
    const handleClickPublish = useCallback(() => {
        goTo(Pages.OP_DEFINITIONS_PUBLISH, { id: 'selected' });
    }, [goTo]);
    const handleClickDelete = useCallback(() => {
        goTo(Pages.OP_DEFINITIONS_DELETE, { id: 'selected' });
    }, [goTo]);
    const handleClickEdit = useCallback(() => {
        goTo(Pages.OP_DEFINITIONS_MULTI_EDIT, { id: 'selected' });
    }, [goTo]);
    const isPrimary = self.isPrimary || self.isSuperUser;
    const isDeletable = selecteds.length > 0 && isPrimary;
    const isLocked = selecteds === null || selecteds === void 0 ? void 0 : selecteds.some(s => s.lockEditing);
    const isLockedToPrimary = selecteds === null || selecteds === void 0 ? void 0 : selecteds.some(s => s.lockEditingToPrimaryAdmins);
    const isPublishRequired = selecteds === null || selecteds === void 0 ? void 0 : selecteds.every(s => s.requiresPublishing);
    const isEditable = !isLocked && (isPrimary || !isLockedToPrimary);
    const actions = useMemo(() => [
        {
            label: i18n.t('delete'),
            Icon: DeleteIcon,
            color: Palette.error,
            enabled: isDeletable,
            onClick: handleClickDelete,
        },
        {
            label: i18n.t('edit'),
            Icon: EditIcon,
            color: Palette.secondary,
            enabled: isEditable,
            onClick: handleClickEdit,
        },
        {
            label: i18n.t('publish'),
            Icon: PublishIcon,
            color: Palette.warning,
            enabled: isPublishRequired,
            visible: isPublishRequired,
            onClick: handleClickPublish,
        },
    ], [
        isDeletable,
        handleClickDelete,
        isEditable,
        handleClickEdit,
        isPublishRequired,
        handleClickPublish,
    ]);
    return React.createElement(SelectionToolbar, { dataType: dataType, actions: actions });
}
export default OpDefinitionsSelectionToolbar;
